import { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "../api";
import { toast } from "sonner";
import CubeLogo from "../components/CubeLogo";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await authApi.login(username, password);
      toast.success("Welcome back");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error((err as { message?: string }).message ?? "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen grid place-items-center px-6 bg-cream-100">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2.5 mb-8 justify-center">
          <CubeLogo size={28} />
          <span className="text-[17px] font-semibold tracking-tight text-ink-900">CORE</span>
        </div>

        <div className="surface p-7 shadow-card">
          <h1 className="display text-[24px] font-medium tracking-tight">
            Sign in to <span className="italic">admin</span>
          </h1>
          <p className="text-[13px] text-ink-500 mt-1.5">Manage portal content for CORE.</p>

          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <div>
              <label className="label" htmlFor="username">Username</label>
              <input
                id="username"
                className="input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                autoFocus
                required
              />
            </div>
            <div>
              <label className="label" htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                className="input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full !h-10 mt-2">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>

        <p className="text-[11.5px] text-ink-500 text-center mt-6">
          <span className="display italic">Celebal Technologies</span> · Internal use only
        </p>
      </div>
    </div>
  );
}
